import { render, staticRenderFns } from "./RingChart.vue?vue&type=template&id=1380542f&scoped=true&"
import script from "./RingChart.vue?vue&type=script&lang=js&"
export * from "./RingChart.vue?vue&type=script&lang=js&"
import style0 from "./RingChart.vue?vue&type=style&index=0&id=1380542f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380542f",
  null
  
)

export default component.exports